export default __webpack_public_path__ + "static/media/info-contacto-emergencia.4867cf04.svg";